import handHygiene from './hand-hygiene';

const elearning = {
    handHygiene,
};

export default elearning;
